// extracted by mini-css-extract-plugin
export default {"container-main":"templates-register-email-sent-module__container-main"};